/**
 * Raiz da suíte Rota (SPEC-v2 2, 9.1): o roteador da suíte com o bloqueador central de navegação.
 * Nenhuma área desce aqui: o login (`/entrar`) é pequeno e cada área é um chunk (9.2). O Painel
 * sobe o provider dele dentro da própria área (`areas/painel/PainelArea.tsx`).
 */
import { useEffect } from 'react';
import { Router } from 'wouter';
import { attachLateHeadAfterPaint } from '@/lib/lateHead';
import { guardNavigation } from '@/lib/navigationBlocker';
import { SuiteRouter } from './suite/SuiteRouter';

export function App() {
  // Favicon e manifest só depois da primeira pintura útil (10.4).
  useEffect(() => {
    attachLateHeadAfterPaint();
  }, []);
  return (
    // Toda navegação passa pelo bloqueador central (mudanças não salvas em Ajustes, 4.14).
    <Router aroundNav={guardNavigation}>
      <SuiteRouter />
    </Router>
  );
}
